var exports = {
  "z": "BackgroundGrid__52BhQ2",
};

module.exports = exports;
